import ConvocatoriaApiRepository from '@/modules/convocatorias/infrastructure/ConvocatoriaApiRepository'
import GetAllTiposConvocatoria from '@/modules/convocatorias/application/GetAllTiposConvocatoria'
import GetTipoConvocatoriaById from '@/modules/convocatorias/application/GetTipoConvocatoriaById'
import GetSubtiposConvocatoriaByTipo from '@/modules/convocatorias/application/GetSubtiposConvocatoriaByTipo'
import GetSubtipoConvocatoriaByTipoAndId from '@/modules/convocatorias/application/GetSubtipoConvocatoriaByTipoAndId'
import GetAllSubtiposConvocatoria from '@/modules/convocatorias/application/GetAllSubtiposConvocatoria'
import GetSubtipoConvocatoriaById from '@/modules/convocatorias/application/GetSubtipoConvocatoriaById'
import GetAllGradosPromocion from '@/modules/convocatorias/application/GetAllGradosPromocion'
import GetGradoPromocionById from '@/modules/convocatorias/application/GetGradoPromocionById'
import GetAllDirigidos from '@/modules/convocatorias/application/GetAllDirigidos'
import GetDirigidoById from '@/modules/convocatorias/application/GetDirigidoById'
import GetAllConvocatorias from '@/modules/convocatorias/application/GetAllConvocatorias'
import GetConvocatoriaById from '@/modules/convocatorias/application/GetConvocatoriaById'
import GetConvocatoriasBySubtipo from '@/modules/convocatorias/application/GetConvocatoriasBySubtipo'
import GetConvocatoriaBySubtipoAndId from '@/modules/convocatorias/application/GetConvocatoriaBySubtipoAndId'
import CreateConvocatoria from '@/modules/convocatorias/application/CreateConvocatoria'
import UpdateConvocatoria from '@/modules/convocatorias/application/UpdateConvocatoria'
import GetAllConvocatoriasPersonal from '@/modules/convocatorias/application/GetAllConvocatoriasPersonal'
import GetConvocatoriasPersonalByPersonalId from '@/modules/convocatorias/application/GetConvocatoriasPersonalByPersonalId'
import GetConvocatoriaPersonalByPersonalIdAndId from '@/modules/convocatorias/application/GetConvocatoriaPersonalByPersonalIdAndId'
import UpdatePersonalPromovido from '@/modules/convocatorias/application/UpdatePersonalPromovido'
import GetAllPersonalByConvocatoria from '@/modules/convocatorias/application/GetAllPersonalByConvocatoria'
import CreatePersonalConvocatoria from '@/modules/convocatorias/application/CreatePersonalConvocatoria'
import DeletePersonalConvocatoria from '@/modules/convocatorias/application/DeletePersonalConvocatoria'

const repository = new ConvocatoriaApiRepository()

const getAllTiposConvocatoria = new GetAllTiposConvocatoria(repository)
const getTipoConvocatoriaById = new GetTipoConvocatoriaById(repository)
const getSubtiposConvocatoriaByTipo = new GetSubtiposConvocatoriaByTipo(repository)
const getSubtipoConvocatoriaByTipoAndId = new GetSubtipoConvocatoriaByTipoAndId(repository)
const getAllSubtiposConvocatoria = new GetAllSubtiposConvocatoria(repository)
const getSubtipoConvocatoriaById = new GetSubtipoConvocatoriaById(repository)
const getAllGradosPromocion = new GetAllGradosPromocion(repository)
const getGradoPromocionById = new GetGradoPromocionById(repository)
const getAllDirigidos = new GetAllDirigidos(repository)
const getDirigidoById = new GetDirigidoById(repository)
const getAllConvocatorias = new GetAllConvocatorias(repository)
const getConvocatoriaById = new GetConvocatoriaById(repository)
const getConvocatoriasBySubtipo = new GetConvocatoriasBySubtipo(repository)
const getConvocatoriaBySubtipoAndId = new GetConvocatoriaBySubtipoAndId(repository)
const createConvocatoria = new CreateConvocatoria(repository)
const updateConvocatoria = new UpdateConvocatoria(repository)
const getAllConvocatoriasPersonal = new GetAllConvocatoriasPersonal(repository)
const getConvocatoriasPersonalByPersonalId = new GetConvocatoriasPersonalByPersonalId(repository)
const getConvocatoriaPersonalByPersonalIdAndId = new GetConvocatoriaPersonalByPersonalIdAndId(repository)
const updatePersonalPromovido = new UpdatePersonalPromovido(repository)
const getAllPersonalByConvocatoria = new GetAllPersonalByConvocatoria(repository)
const createPersonalConvocatoria = new CreatePersonalConvocatoria(repository)
const deletePersonalConvocatoria = new DeletePersonalConvocatoria(repository)

export default {
  namespaced: true,

  state: {
    tiposConvocatoria: [],
    tipoConvocatoria: null,
    subtiposConvocatoria: [],
    subtipoConvocatoria: null,
    gradosPromocion: [],
    gradoPromocion: null,
    dirigidos: [],
    dirigido: null,
    convocatorias: [],
    convocatoria: null,
    convocatoriasPersonal: [],
    convocatoriaPersonal: null,
    personalPorConvocatoria: [],
  },

  getters: {
    getTiposConvocatoria: (state) => state.tiposConvocatoria,
    getTipoConvocatoria: (state) => state.tipoConvocatoria,
    getSubtiposConvocatoria: (state) => state.subtiposConvocatoria,
    getSubtipoConvocatoria: (state) => state.subtipoConvocatoria,
    getGradosPromocion: (state) => state.gradosPromocion,
    getGradoPromocion: (state) => state.gradoPromocion,
    getDirigidos: (state) => state.dirigidos,
    getDirigido: (state) => state.dirigido,
    getConvocatorias: (state) => state.convocatorias,
    getConvocatoria: (state) => state.convocatoria,
    getConvocatoriasPersonal: (state) => state.convocatoriasPersonal,
    getConvocatoriaPersonal: (state) => state.convocatoriaPersonal,
    getPersonalPorConvocatoria: (state) => state.personalPorConvocatoria,
  },

  mutations: {
    SET_TIPOS_CONVOCATORIA(state, tipos) {
      state.tiposConvocatoria = tipos
    },
    SET_TIPO_CONVOCATORIA(state, tipo) {
      state.tipoConvocatoria = tipo
    },
    SET_SUBTIPOS_CONVOCATORIA(state, subtipos) {
      state.subtiposConvocatoria = subtipos
    },
    SET_SUBTIPO_CONVOCATORIA(state, subtipo) {
      state.subtipoConvocatoria = subtipo
    },
    SET_GRADOS_PROMOCION(state, grados) {
      state.gradosPromocion = grados
    },
    SET_GRADO_PROMOCION(state, grado) {
      state.gradoPromocion = grado
    },
    SET_DIRIGIDOS(state, dirigidos) {
      state.dirigidos = dirigidos
    },
    SET_DIRIGIDO(state, dirigido) {
      state.dirigido = dirigido
    },
    SET_CONVOCATORIAS(state, convocatorias) {
      state.convocatorias = convocatorias
    },
    SET_CONVOCATORIA(state, convocatoria) {
      state.convocatoria = convocatoria
    },
    SET_CONVOCATORIAS_PERSONAL(state, convocatoriasPersonal) {
      state.convocatoriasPersonal = convocatoriasPersonal
    },
    SET_CONVOCATORIA_PERSONAL(state, convocatoriaPersonal) {
      state.convocatoriaPersonal = convocatoriaPersonal
    },
    SET_PERSONAL_POR_CONVOCATORIA(state, personal) {
      state.personalPorConvocatoria = personal
    },
    UPDATE_PERSONAL_POR_CONVOCATORIA(state, { idConvocatoriaPersonal, idPersonal, aceptado, promocionado }) {
      const index = state.personalPorConvocatoria.findIndex(
        (item) => item.idConvocatoriaPersonal === idConvocatoriaPersonal || item.id_personal === idPersonal
      )

      if (index === -1) return

      const current = state.personalPorConvocatoria[index]
      const updated = {
        ...current,
        aceptado: typeof aceptado === 'boolean' ? aceptado : current.aceptado,
        promocionado: typeof promocionado === 'boolean' ? promocionado : current.promocionado,
      }

      state.personalPorConvocatoria.splice(index, 1, updated)
    },
  },

  actions: {
    async fetchAllTiposConvocatoria({ commit }) {
      try {
        const result = await getAllTiposConvocatoria.execute()
        commit('SET_TIPOS_CONVOCATORIA', result)
        return result
      } catch (error) {
        console.error('Error en fetchAllTiposConvocatoria:', error)
        throw error
      }
    },

    async fetchTipoConvocatoriaById({ commit }, id) {
      try {
        const result = await getTipoConvocatoriaById.execute(id)
        commit('SET_TIPO_CONVOCATORIA', result)
        return result
      } catch (error) {
        console.error('Error en fetchTipoConvocatoriaById:', error)
        throw error
      }
    },

    async fetchSubtiposConvocatoriaByTipo({ commit }, idTipoConvocatoria) {
      try {
        const result = await getSubtiposConvocatoriaByTipo.execute(idTipoConvocatoria)
        commit('SET_SUBTIPOS_CONVOCATORIA', result)
        return result
      } catch (error) {
        console.error('Error en fetchSubtiposConvocatoriaByTipo:', error)
        throw error
      }
    },

    async fetchSubtipoConvocatoriaByTipoAndId({ commit }, { idTipoConvocatoria, id }) {
      try {
        const result = await getSubtipoConvocatoriaByTipoAndId.execute(idTipoConvocatoria, id)
        commit('SET_SUBTIPO_CONVOCATORIA', result)
        return result
      } catch (error) {
        console.error('Error en fetchSubtipoConvocatoriaByTipoAndId:', error)
        throw error
      }
    },

    async fetchAllSubtiposConvocatoria({ commit }) {
      try {
        const result = await getAllSubtiposConvocatoria.execute()
        commit('SET_SUBTIPOS_CONVOCATORIA', result)
        return result
      } catch (error) {
        console.error('Error en fetchAllSubtiposConvocatoria:', error)
        throw error
      }
    },

    async fetchSubtipoConvocatoriaById({ commit }, id) {
      try {
        const result = await getSubtipoConvocatoriaById.execute(id)
        commit('SET_SUBTIPO_CONVOCATORIA', result)
        return result
      } catch (error) {
        console.error('Error en fetchSubtipoConvocatoriaById:', error)
        throw error
      }
    },

    async fetchAllGradosPromocion({ commit }) {
      try {
        const result = await getAllGradosPromocion.execute()
        commit('SET_GRADOS_PROMOCION', result)
        return result
      } catch (error) {
        console.error('Error en fetchAllGradosPromocion:', error)
        throw error
      }
    },

    async fetchGradoPromocionById({ commit }, id) {
      try {
        const result = await getGradoPromocionById.execute(id)
        commit('SET_GRADO_PROMOCION', result)
        return result
      } catch (error) {
        console.error('Error en fetchGradoPromocionById:', error)
        throw error
      }
    },

    async fetchAllDirigidos({ commit }) {
      try {
        const result = await getAllDirigidos.execute()
        commit('SET_DIRIGIDOS', result)
        return result
      } catch (error) {
        console.error('Error en fetchAllDirigidos:', error)
        throw error
      }
    },

    async fetchDirigidoById({ commit }, id) {
      try {
        const result = await getDirigidoById.execute(id)
        commit('SET_DIRIGIDO', result)
        return result
      } catch (error) {
        console.error('Error en fetchDirigidoById:', error)
        throw error
      }
    },

    async fetchAllConvocatorias({ commit }) {
      try {
        const result = await getAllConvocatorias.execute()
        commit('SET_CONVOCATORIAS', result)
        return result
      } catch (error) {
        console.error('Error en fetchAllConvocatorias:', error)
        throw error
      }
    },

    async fetchConvocatoriaById({ commit }, idConvocatoria) {
      try {
        const result = await getConvocatoriaById.execute(idConvocatoria)
        commit('SET_CONVOCATORIA', result)
        return result
      } catch (error) {
        console.error('Error en fetchConvocatoriaById:', error)
        throw error
      }
    },

    async fetchConvocatoriasBySubtipo({ commit }, idSubTipo) {
      try {
        const result = await getConvocatoriasBySubtipo.execute(idSubTipo)
        commit('SET_CONVOCATORIAS', result)
        return result
      } catch (error) {
        console.error('Error en fetchConvocatoriasBySubtipo:', error)
        throw error
      }
    },

    async fetchConvocatoriaBySubtipoAndId({ commit }, { idSubTipo, idConvocatoria }) {
      try {
        const result = await getConvocatoriaBySubtipoAndId.execute(idSubTipo, idConvocatoria)
        commit('SET_CONVOCATORIA', result)
        return result
      } catch (error) {
        console.error('Error en fetchConvocatoriaBySubtipoAndId:', error)
        throw error
      }
    },

    async createConvocatoria({ dispatch }, payload) {
      try {
        const result = await createConvocatoria.execute(payload)
        await dispatch('fetchAllConvocatorias')
        return result
      } catch (error) {
        console.error('Error en createConvocatoria:', error)
        throw error
      }
    },

    async updateConvocatoria({ dispatch }, { idConvocatoria, payload }) {
      try {
        const result = await updateConvocatoria.execute(idConvocatoria, payload)
        await dispatch('fetchAllConvocatorias')
        return result
      } catch (error) {
        console.error('Error en updateConvocatoria:', error)
        throw error
      }
    },

    async fetchAllConvocatoriasPersonal({ commit }) {
      try {
        const result = await getAllConvocatoriasPersonal.execute()
        commit('SET_CONVOCATORIAS_PERSONAL', result)
        return result
      } catch (error) {
        console.error('Error en fetchAllConvocatoriasPersonal:', error)
        throw error
      }
    },

    async fetchConvocatoriasPersonalByPersonalId({ commit }, idPersonal) {
      try {
        const result = await getConvocatoriasPersonalByPersonalId.execute(idPersonal)
        commit('SET_CONVOCATORIAS_PERSONAL', result)
        return result
      } catch (error) {
        console.error('Error en fetchConvocatoriasPersonalByPersonalId:', error)
        throw error
      }
    },

    async fetchConvocatoriaPersonalByPersonalIdAndId({ commit }, { idPersonal, idConvocatoriaPersonal }) {
      try {
        const result = await getConvocatoriaPersonalByPersonalIdAndId.execute(idPersonal, idConvocatoriaPersonal)
        commit('SET_CONVOCATORIA_PERSONAL', result)
        return result
      } catch (error) {
        console.error('Error en fetchConvocatoriaPersonalByPersonalIdAndId:', error)
        throw error
      }
    },

    async createPersonalConvocatoria({ commit }, { idPersonal, payload }) {
      try {
        const result = await createPersonalConvocatoria.execute(idPersonal, payload)
        commit('SET_SNACKBAR_MESSAGE', 'Personal asignado a convocatoria correctamente.', { root: true })
        return result
      } catch (error) {
        console.error('Error en createPersonalConvocatoria:', error)
        throw error
      }
    },

    async updatePersonalConvocatoria({ commit }, { idPersonal, idConvocatoriaPersonal, payload }) {
      try {
        const result = await updatePersonalPromovido.execute(idPersonal, idConvocatoriaPersonal, payload)
        return result
      } catch (error) {
        console.error('Error en updatePersonalConvocatoria:', error)
        throw error
      }
    },

    async deletePersonalConvocatoria({ commit }, { idPersonal, idConvocatoriaPersonal }) {
      try {
        const result = await deletePersonalConvocatoria.execute(idPersonal, idConvocatoriaPersonal)
        commit('SET_SNACKBAR_MESSAGE', 'Asignación de personal eliminada correctamente.', { root: true })
        return result
      } catch (error) {
        console.error('Error en deletePersonalConvocatoria:', error)
        throw error
      }
    },

    async fetchPersonalByConvocatoria({ commit }, idConvocatoria) {
      try {
        const result = await getAllPersonalByConvocatoria.execute(idConvocatoria)
        commit('SET_PERSONAL_POR_CONVOCATORIA', result)
        return result
      } catch (error) {
        console.error('Error en fetchPersonalByConvocatoria:', error)
        throw error
      }
    },
  },
}
